import OBase from './OBase';
import * as Geometry from '../geometry';

export default class ScaleNU extends OBase {
  update () {
    let geomInputTree = this.getObjectInput('Geometry');
    let planeInputTree = this.getPlaneInput('Plane', false);
    let scaleXInputTree = this.getFloatInput('Scale X');
    let scaleYInputTree = this.getFloatInput('Scale Y');
    let scaleZInputTree = this.getFloatInput('Scale Z');

    let geometryOutput = this.outputs['Geometry'].paramObject;

    let dataTrees = [geomInputTree, planeInputTree, scaleXInputTree, scaleYInputTree, scaleZInputTree];
    let outDataTrees = [];
    Geometry.makeMultiplePairs(dataTrees, outDataTrees);

    var outTree = new Geometry.DataTree();
    for (let i = 0; i < outDataTrees[0].branches.length; i++) {
      for (let j = 0; j < outDataTrees[0].branches[i].length; j++) {
        let geomInput = outDataTrees[0].branches[i][j];
        let planeInput = outDataTrees[1].branches[i][j];
        let scaleXInput = outDataTrees[2].branches[i][j];
        let scaleYInput = outDataTrees[3].branches[i][j];
        let scaleZInput = outDataTrees[4].branches[i][j];

        var scaledObject = ScaleNUObject(geomInput, planeInput, scaleXInput, scaleYInput, scaleZInput);
        outTree.add(scaledObject, outDataTrees[0].paths[i]);
      }
    }

    geometryOutput.value = outTree;
  }
}

function ScaleNUObject (geomInput, planeInput, scaleXInput, scaleYInput, scaleZInput) {
  if (geomInput instanceof THREE.Geometry) {
    let g = geomInput.clone();
    g.vertices.forEach(v => {
      v.set(v.x - planeInput.center.x, v.y - planeInput.center.y, v.z - planeInput.center.z);
      // v.multiply(new THREE.Vector3(scaleXInput, scaleYInput, scaleZInput))
      v.multiply(new THREE.Vector3(scaleXInput, scaleZInput, scaleYInput));
      v.set(v.x + planeInput.center.x, v.y + planeInput.center.y, v.z + planeInput.center.z);
    });

    return g;
  } else {
    let paths = geomInput;
    let scaledPaths = [];

    for (let k = 0; k < paths.length; k++) {
      let path = paths[k];
      scaledPaths.push([]);

      for (let t = 0; t < path.length; t++) {
        let pt = path[t];
        let scaledPt = new ClipperLib.DoublePoint(
          pt.X - planeInput.center.x,
          pt.Y - planeInput.center.y
        );

        let p = new THREE.Vector3(scaledPt.X, scaledPt.Y, 0);
        p.multiply(new THREE.Vector3(scaleXInput, scaleYInput, scaleZInput));

        scaledPt = new ClipperLib.DoublePoint(
          p.x + planeInput.center.x,
          p.y + planeInput.center.y
        );
        scaledPaths[k].push(scaledPt);
      }
    }

    return scaledPaths;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/ScaleNU.js